import { AccountLinkResponseDto, INTEGRATION_CODE } from "../../../../../../models/IntegrationsTypes";
import IntegrationsService from "../../../../../../services/api/integrations-service";
import { TYPE, rootContainer } from "../../../../../../services/container/root";
import OAuthHandler from "./outh-handler";

class IntegratorOAuthHandler extends OAuthHandler<AccountLinkResponseDto> {
    private readonly _integrationCode: INTEGRATION_CODE;

    private get integrationsService(): IntegrationsService {
        return rootContainer.get<IntegrationsService>(TYPE.IntegrationsService);
    }

    constructor(integrationCode: INTEGRATION_CODE) {
        super();
        this._integrationCode = integrationCode;
    }

    protected async createLink(isSandbox: boolean, inputData?: Record<string, any>): Promise<AccountLinkResponseDto> {
        return this.integrationsService.createAccountLink(this._integrationCode, inputData, isSandbox);
    }

    protected async handleMessagePayload(event: any, linkResponse: AccountLinkResponseDto, inputData?: Record<string, any>): Promise<unknown> {
        return {
            ...inputData,
            accountLinkResponse: linkResponse,
            oauthPayload: event.data.payload,
        };
    }
}

export default IntegratorOAuthHandler;
